import React from "react";
import { useControls, button } from "leva";
import { useState, useEffect, useRef } from "react";
import SubmitForm from "./SubmitForm.jsx"
// import * as MyLibrary from 'leva';
// console.log(MyLibrary);

function CreateLevaFromJson({ iframeRef, store }) {
  console.log("RENDERED!")
  const isIframeLoaded = useRef(false);
  const renderChange = useRef(true);
  const [renderChangeState, updateRenderChangeState] = useState(false)
  const [showSubmitForm, setShowSubmitForm] = useState(false);
  const handleFormSubmit = () => { setShowSubmitForm(false);};

  let config = [
    {"name": "randomize", "type": "button", props:{"label":"reload local", "onChange":"reloadIframe"}},
    {"name":"C1", props:{"label":"", value:"#000000", }, lookup:{"onChange":"updateColors"}},
    {"name":"C2", props:{"label":"", value:"#000000", render:true,}, lookup:{"onChange":"updateColors"}},
    {"name":"C3", props:{"label":"", value:"#000000", render:true,}, lookup:{"onChange":"updateColors"}},
    {"name":"C4", props:{"label":"", value:"#000000", render:true,}, lookup:{"onChange":"updateColors"}},
    {"name":"C5", props:{"label":"", value:"#000000", render:true,}, lookup:{"onChange":"updateColors"}},
    {"name":"C6", props:{"label":"", value:"#000000", render:true,}, lookup:{"onChange":"updateColors"}},
    {"name": "email me", "type": "button", props:{"label":"email me", "onChange":"sendEmail"}},
    {"name": "download", "type": "button", props:{"label":"download"}, lookup:{"onChange":"saveLargeCanvas"}},

    // {"name":"logM" , "type": "button",    props:{"label":"logM" }, lookup:{"onChange":"logM"}},
    // {"name":"logCols" , "type": "button",props:{"label":"logCols"}, lookup:{"onChange":"logCols"}},
    // {"name":"logM" , "type": "button",   props:{"label":"noop", "onChange":"noop" }},

    // {"name":"t001" ,    props:{"label":"",value:"", editable:false }},
    // {"name":"t002" ,    props:{"label":"",value:"",  }},
    // {"name": "test-toggle", "type": "button", props:{"label":"toggle", "onChange":"toggleRenderChange"}},

  ] 

  config = window.AppConfig.config;

  const localFn = {
    noop:noop,
    reloadIframe:reloadIframe,
    sendEmail:sendEmail,
    toggleRenderChange:toggleRenderChange,
    setEdition:setEdition,
    openUrlInNewTab:openUrlInNewTab
  }
  function toggleRenderChange(){
    renderChange.current = !renderChange.current
    console.log(renderChange.current)
    // updateRenderChangeState(!renderChangeState)
    // updateRenderChangeState(prevCheck => !prevCheck)
    // console.log(renderChangeState);
  }
  function reloadIframe() {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src;
    }
  } 
  function noop() {
    console.log("noop")
  }
  function sendEmail() {
    setShowSubmitForm(true)
  }
  function openUrlInNewTab(url = "https://trameparis.com/collections/enlace-by-aranda-lasch") {
    window.open(url, '_blank');
}
  function runLocalFnfunc(func) {
    localFn[func]();
  }
  function runIframeFn(func) {
    console.log(func)
    console.log(iframeRef.current.contentWindow[func])
    if (iframeRef.current.contentWindow[func]) {
      iframeRef.current.contentWindow[func]();
    }
  }
  function runIframeFnArg(func,Arg) {
    if (iframeRef.current.contentWindow[func]) {
      iframeRef.current.contentWindow[func](Arg);
    }
  }
  function passUItoWindow(item){
    let val = store.get(item.name)
    console.log("passing", item.name, val)
    updateIframeVals(item.name, val)
    console.log(config)
  }
  function updateIframeVals(target,data){ 
    if(iframeRef.current.contentWindow.updateM){
      iframeRef.current.contentWindow.updateM(target,data)
    }
  }

  function setEdition(){
    console.log("setEdition")
    let start = window.AppConfig.editionStart || 0
    let idx = store.get("Edition")
    if(start == 1){
      idx -= 1
    }
    console.log("start",start)
    console.log("idx",idx)
    if(  typeof idx === 'number' ){
      let val
      if(start == "finale"){//for finale, this is dumb but it works
        let a = [36, 75, 143, 148, 230, 242, 251, 252, 264, 612, 681, 780, 842]
        idx = a.indexOf(idx)
        val = window.AppConfig.seeds[idx]
        console.log(val)
      }else{
        val = window.AppConfig.seeds[idx]
      }
      if(val){
        console.log(val)
        updateIframeVals("nextSeed", val)
        runIframeFn("setSeed")
      }
    }
  }

  // Initializing controls based on the configuration
  const controls = config.reduce((acc, item) => {
    if (item.type === "button"){
      if(item.lookup?.onChange){
        acc[item.name] = button(() => {runIframeFn(item.lookup.onChange)});
      }
      else{
        acc[item.name] = button(() => {runLocalFnfunc(item.props.onChange)});
      }
      // console.log(acc[item.name])
      acc[item.name].label = item.label
    }else{
      // acc[item.name] = item.props // CANT DO A SHALLOW COPY FOOL
      acc[item.name] = { ...item.props };
      // if(acc[item.name].onChange){
      if(item.props.onChange){
        acc[item.name].onChange = (()=>{
          if(isIframeLoaded.current){
            runLocalFnfunc(item.props.onChange)  
          }
        })
      }else if(item.lookup){
        acc[item.name].onChange = (()=>{
          if(isIframeLoaded.current){
            passUItoWindow(item)
            runIframeFn(item.lookup.onChange)
          }
        })
      }else{ // for uniform updates without a FN, should prop just add a noop inside the app so there has to be a delcared onchange string? 
        // solution to above: just add an onChange funcito nthat doesnt exist. passUItoWindow gets called, runIframeFn doesnt pass the if check
        acc[item.name].onChange = (()=>{ 
          if(isIframeLoaded.current){
              passUItoWindow(item)
            }
          })
      }

      if("render" in item.props){
        console.log("RENDERVAL",item.props.render)
        if(item.props.render === true){
          item.props.render = () => {
            console.log(renderChange.current); 
            return renderChange.current
            // console.log(renderChangeState); 
            // return renderChangeState
          }
        }else{
          item.props.render = () => {
            console.log(renderChange.current); 
            return renderChange.current
            // console.log(renderChangeState); 
            // return renderChangeState
          }
        }
      }
      // if("render" in item.props){
      //   acc[item.name].render = () => item.props.render
      // }
      // acc[item.name].disabled = false
      // acc[item.name].hidden = true // doesnt work
      // acc[item.name].render = () => true

      if(item.props.optionsLength ){ // for Edition Select
        let start = window.AppConfig.editionStart || 0
        acc[item.name].options = Array.from({length:item.props.optionsLength}, (_, index) => index + start)
      }
    }
    console.log("")
    console.log("ctnl", acc[item.name])
    console.log("item", item)
    console.log("src", config[item.name])
    console.log("")
    // debugger
    return acc;
  }, {});
  
    useEffect(() => {
      const updateControls = () => {  
        if (iframeRef.current) {
          isIframeLoaded.current = false;
          config.forEach(item => {                        // rewrite with controls, config no loger same opbject......   only item.props.value  will be out of date? and only happens before iframe loads... so they will be tha same?
            if(item.lookup && item.type !== "button"){
              if(iframeRef.current.contentWindow.M){
                const value = iframeRef.current.contentWindow.M.var[item.name] || item.props.value || 'default value';
                if (value === store.get(item.name)) {return}//exit if the value is the same, dont call onChange
                if(value === "NONE"){ // if the value is NONE, we disable the control. this happens when the app is telling us this var isnt active. 
                  const v2 = "#000000"
                  store.set({ [item.name]: v2 }, false); 
                  console.log("inactive control ", item.name, "set to", v2)
                  // renderChange.current = false
                  // updateRenderChangeState(false)
                }else{
                  store.set({ [item.name]: value }, false); 
                  console.log("active control   ", item.name, "set to", value)
                }
                // store.setSettingsAtPath(item.name, { disabled: true });
              }
            } 
          }); 
          isIframeLoaded.current = true;
          console.log("set isIframeLoaded to", isIframeLoaded.current)
        }
      };
  
      const currentIframe = iframeRef.current;
      currentIframe.addEventListener('load', updateControls);
      updateControls();
  
      return () => {
        if (currentIframe) {
           currentIframe.removeEventListener('load', updateControls);
           isIframeLoaded.current = false;
        }
      };
    }, [iframeRef, store, config, controls]); 

  console.log("controls",controls)
  console.log(store)
  useControls(controls, { store }); 
  

  return (
    <>
      {showSubmitForm && <SubmitForm onSubmit={handleFormSubmit} iframeRef = {iframeRef} uploadM={true} uploadImg={true} />}
    </>
  )
}

export default CreateLevaFromJson;
